"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Briefcase, Users, GraduationCap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServices() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: Briefcase,
    title: "Applied Behavior Analysis (ABA) Therapy",
    description: "Evidence-based ABA therapy tailored to each child's unique needs, helping them develop essential skills and reach their full potential.",
    link: "/ServicesPage"
  }, {
    icon: Users,
    title: "Parent and Caregiver Training",
    description: "Comprehensive training programs that empower parents and caregivers with strategies to support their child's development at home.",
    link: "/ServicesPage"
  }, {
    icon: GraduationCap,
    title: "School-Based Support",
    description: "Collaborative school-based services that ensure consistent support across all learning environments for optimal outcomes.",
    link: "/ServicesPage"
  }];
  const refs = [section1Ref, section2Ref, section3Ref];
  const visibles = [section1Visible, section2Visible, section3Visible];
  return <section id="our-services" className="py-16 lg:py-24 bg-dark-background">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-foreground-dark mb-4">Our Services</h2>
          <p className="text-foreground-dark/80 max-w-2xl mx-auto">Compassionate, evidence-based services designed to support children and families in Miami-Dade County. We serve children and teens with autism. Services are available at your home or other community settings.<div data-ast-id="f:/src/pages/Home/sections/OurServices.tsx|sig:562uq3" data-ast-start="2138" data-ast-end="2155"><br /></div></p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] ${visibles[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Link to={service.link} className="block h-full focus-ring">
                  <Card className="h-full hover-lift hover:border-primary/30 transition-all duration-[var(--duration-medium)] cursor-pointer group">
                    <CardHeader>
                      <div className="mb-4 inline-flex p-3 rounded-[var(--radius-md)] bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                        <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                      </div>
                      <CardTitle className="text-xl group-hover:text-primary transition-colors duration-[var(--duration-fast)]">
                        {service.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <CardDescription className="leading-relaxed">
                        {service.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}